export default __webpack_public_path__ + "static/media/chart-line.7572a249.svg";